import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { WixConnect } from 'shared/utils/wix-connect';
import pubsub from 'shared/utils/pubsub';
import { byPopoutSide } from 'shared/utils/popout/calculate-position';

import events from 'shared/constants/events';
import { sides, popoutPositions, trianglePositions } from 'shared/constants/popout';

import Popout from 'shared/components/popout/popout';

import styles from './tooltip.styl';


const HIDE_TIMEOUT = 200;
let hideTimeoutId;


export function showTooltip(config) {
  pubsub.publish(events.TOOLTIP.SHOW, config);
}

export function hideTooltip() {
  pubsub.publish(events.TOOLTIP.HIDE);
}


@WixConnect(styles)
export default class TooltipPopout extends React.Component {

  state = {
    popoutComponent: Popout,
    visible: false,
  };

  componentDidMount() {
    this.showTooltipUnsubscribe = pubsub.subscribe(events.TOOLTIP.SHOW, this.showTooltip);
    this.hideTooltipUnsubscribe = pubsub.subscribe(events.TOOLTIP.HIDE, this.hideTooltip);
  }

  componentDidUpdate(prevProps, prevState) {
    const { visible, tooltipId } = this.state;

    if (visible && !_.isEqual(this.state, prevState)) {
      // update position if popout is visible
      this.updatePosition();
    }

    if (visible !== prevState.visible) {
      const eventId = visible ?
        events.TOOLTIP.DID_SHOW :
        events.TOOLTIP.DID_HIDE;

      pubsub.publish(eventId, tooltipId);
    }
  }

  componentWillUnmount() {
    this.showTooltipUnsubscribe();
    this.hideTooltipUnsubscribe();
  }

  get Popout() {
    return this.state.popoutComponent;
  }

  @autobind
  showTooltip(config) {
    this.preventHide();

    this.setState({
      visible: true,

      preventHideOnHover: false,
      popoutComponent: Popout,
      className: '',
      innerClassName: '',
      triangleClassName: '',
      content: null,
      popoutSide: sides.RIGHT,
      popoutPosition: popoutPositions.CENTER,
      trianglePosition: trianglePositions.CENTER,
      referenceElement: null,

      ...config,
    });
  }

  @autobind
  hideTooltip() {
    const timeout = this.state.preventHideOnHover ? HIDE_TIMEOUT : 0;

    hideTimeoutId = setTimeout(() => {
      this.setState({
        visible: false,
      });
    }, timeout);
  }

  preventHide() {
    clearTimeout(hideTimeoutId);
  }

  @autobind
  handleMouseEnter() {
    if (this.state.preventHideOnHover) {
      this.preventHide();
    }
  }

  @autobind
  handleMouseLeave() {
    this.hideTooltip();
  }

  calculatePosition() {
    const { referenceElement, popoutSide, popoutPosition, trianglePosition } = this.state;
    return byPopoutSide(referenceElement, this.popout, { popoutSide, popoutPosition, trianglePosition });
  }

  updatePosition() {
    const { top, left, offsetX } = this.calculatePosition();

    this.popout.style.top = `${top}px`;
    this.popout.style.left = `${left}px`;

    const transformStyle = `translateX(${offsetX}px) rotate(45deg)`;
    const before = this.popout.firstElementChild;
    const after = this.popout.lastElementChild;

    before.style.transform = transformStyle;
    after.style.transform = transformStyle;
  }

  @autobind
  getPopoutRef(node) {
    this.popout = node;
  }

  render() {
    const {
      visible, content, left, top,
      className, innerClassName, triangleClassName,
      popoutSide, popoutPosition, trianglePosition,
      onClickOutside,
    } = this.state;

    const styleNames = classnames('popout', {
      positioned: visible,
    });
    const innerClassNames = classnames(styles['popout-inner'], innerClassName);

    return (
      <this.Popout getRef={this.getPopoutRef}
                   onClickOutside={onClickOutside}
                   popoutSide={popoutSide}
                   popoutPosition={popoutPosition}
                   trianglePosition={trianglePosition}
                   styleName={styleNames}
                   className={className}
                   innerClassName={innerClassNames}
                   triangleClassName={triangleClassName}
                   style={{ left, top }}
                   onMouseEnter={this.handleMouseEnter}
                   onMouseLeave={this.handleMouseLeave}>
        {content}
      </this.Popout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/tooltip/tooltip-popout.js